import { finalPageData } from '../../content/finalPageData';
import { formatRub, plotPriceRatesRub } from '../../features/genplan/lib/formatPlotValue';
import { analyticsGoals, trackAnalyticsGoal } from '../../lib/analytics/yandexMetrika';
import horizonHouse960 from '../../assets/images/responsive/horizon-house-960.jpg';
import horizonHouse1680 from '../../assets/images/responsive/horizon-house-1680.jpg';
import styles from './LakeHousesSection.module.scss';

const facts = [
  ['24', 'участков'],
  ['1', 'этаж'],
  ['130–180 м²', 'площадь домов'],
  ['3–4', 'спальни'],
] as const;

export function LakeHousesSection() {
  const telegram = finalPageData.contacts.telegram;

  return (
    <section className={styles.section} id="lake-houses" aria-labelledby="lake-houses-title">
      <header className={styles.header} data-reveal>
        <p className={styles.eyebrow}>Архитектурный квартал «Горизонт»</p>
        <h2 id="lake-houses-title">Дом, улица и окружение — в едином стиле</h2>
        <p className={styles.subtitle}>
          Одноэтажные дома, продуманные планировки и цельный архитектурный облик.
        </p>
      </header>

      <figure className={styles.architecture} data-reveal data-reveal-delay="1">
        <picture>
          <source media="(max-width: 767px)" srcSet={horizonHouse960} />
          <img
            src={horizonHouse1680}
            srcSet={`${horizonHouse960} 960w, ${horizonHouse1680} 1680w`}
            sizes="(max-width: 767px) calc(100vw - 40px), calc(100vw - (2 * var(--page-gutter)))"
            width="1680"
            height="938"
            loading="lazy"
            decoding="async"
            alt="Одноэтажный дом квартала «Горизонт» с панорамным остеклением и террасой"
          />
        </picture>
        <figcaption className={styles.architectureCaption}>
          <span className={styles.architectureNumber}>01</span>
          <span>
            <strong>Архитектура квартала</strong>
            <small>Дом, терраса и природное окружение</small>
          </span>
        </figcaption>
        <span className={styles.architectureMark} aria-hidden="true">
          Горизонт
        </span>
      </figure>

      <div className={styles.story}>
        <div className={styles.copy} data-reveal>
          <p>
            Отдельный проект в составе «Лучезарной Долины»: 24 участка в дальней части посёлка,
            объединённые единой архитектурной концепцией.
          </p>
          <p>Квартал создан для тех, кому важно заранее понимать, каким будет окружение дома.</p>
          <p>
            В проекте — одноэтажные дома в скандинавском стиле с плоскими кровлями и панорамным
            остеклением. Невысокая застройка сохраняет ощущение простора и приватности, а единая
            архитектура формирует аккуратную современную улицу и сообщество соседей со схожим
            отношением к своему дому.
          </p>
        </div>
        <dl className={styles.facts} data-reveal data-reveal-delay="1">
          {facts.map(([value, label]) => (
            <div key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <footer className={styles.footer} data-reveal>
        <div className={styles.price}>
          <span>Стоимость земли в этой зоне</span>
          <strong>{formatRub(plotPriceRatesRub.withContractor)} / сотка</strong>
        </div>
        <div className={styles.timeline}>
          <p>
            Проекты, комплектации и цены домов находятся на этапе утверждения. Ориентировочное
            начало строительства первых демонстрационных домов — октябрь 2026 года.
          </p>
          <p>Строительство выполняется утверждёнными подрядчиками.</p>
          {telegram ? (
            <a
              href={telegram.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackAnalyticsGoal(analyticsGoals.telegramClick)}
            >
              Узнать о старте продаж <span aria-hidden="true">↗</span>
            </a>
          ) : null}
        </div>
      </footer>
    </section>
  );
}
